import { getService } from 'data/function';
import { ConfirmationModal } from 'modules/ui';
export class ModalProcessor {
    static get ModalService() {
        return getService('ModalService');
    }
    static async process({ message, trackingProperties, source }) {
        try {
            const { title, titleClass, body, confirm, confirmClass, cancel, modalClass, modalSizeClass, bodyClass, bodyContentClass, footerClass, footerContentClass } = message.content;
            const modal = await ModalProcessor.ModalService.showModal(ConfirmationModal({
                title: {
                    class: titleClass,
                    text: title,
                },
                body,
                buttons: {
                    confirm: {
                        class: confirmClass,
                        text: confirm,
                    },
                    cancel: {
                        text: cancel,
                    },
                },
                modalClass,
                modalSizeClass,
                bodyClass,
                bodyContentClass,
                footerClass,
                footerContentClass,
            }));
            const modalResponse = await modal.close;
            const messageResponse = {
                response: modalResponse,
                trackingProperties,
            };
            source.postMessage(messageResponse, '*');
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
    }
    static showOverlayAndBlockScroll({ message, trackingProperties, source }) {
        this.blockInPosition = {
            scrollTop: window.pageYOffset || document.documentElement.scrollTop,
            scrollLeft: window.pageXOffset || document.documentElement.scrollLeft,
        };
        const messageResponse = {
            response: window.scrollY,
            trackingProperties,
        };
        source.postMessage(messageResponse, '*');
        this.addOverlayOnHeader(true);
        document.addEventListener('scroll', this.onScroll.bind(this), true);
    }
    static removeOverlayAndReleaseScroll() {
        this.blockInPosition = {
            scrollTop: undefined,
            scrollLeft: undefined,
        };
        this.addOverlayOnHeader(false);
        document.removeEventListener('scroll', this.onScroll.bind(this), true);
    }
    static addOverlayOnHeader(add) {
        const headerOverlay = document.getElementById('header-overlay');
        if (headerOverlay) {
            add
                ? headerOverlay.classList.add('main-header--overlay')
                : headerOverlay.classList.remove('main-header--overlay');
        }
    }
    static onScroll() {
        const lockScroll = Boolean(this.blockInPosition.scrollTop !== undefined &&
            this.blockInPosition.scrollLeft !== undefined);
        if (lockScroll) {
            window.scrollTo(this.blockInPosition.scrollLeft, this.blockInPosition.scrollTop);
        }
    }
}
ModalProcessor.blockInPosition = {
    scrollTop: undefined,
    scrollLeft: undefined,
};
